<template>
  <div>
    <template>
      <div class="container-fluid my-4">
        <div class="row">
          <div class="col-6">
            <h6 class="m-0 text-mcf-color">
              {{ title }}
            </h6>
          </div>
          <div class="col-6">
          </div>
        </div>
      </div>
    <PersonalInfoEdit class="mb-5"></PersonalInfoEdit>
    </template>
    <Popup :isOpen.sync="popup.isOpen" :title="popup.title" :content="popup.content" :mode="popup.mode"
      @confirm="popup.confirm" @close="popup.close"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import PersonalInfoEdit from '@/components/mcf/PersonalInfoEdit.vue';
import Popup from '@/components/Popup.vue';

import pageSettingGetter from '@/utils/pageSettingGetter';

export default {
  components: {
    PersonalInfoEdit,
    Popup,
  },
  data() {
    return {
      title: '',
      popup: {
        // 是否開啟
        isOpen: false,
        // 標題
        title: '',
        // 內容
        content: '',
        // 顯示模式
        mode: 'default',
        // 按確定後執行動作
        confirm: () => {},
        // 按取消後執行動作
        close: () => {},
      },
    };
  },
  computed: {
    ...mapGetters('memberSource', ['isAnswerChanged']),
  },
  created() {
    const vm = this;

    // 取得頁面設定
    vm.$store.dispatch('getPageSetting', 'PersonalInfo')
      .then((setting) => {
        // 標題
        const title = pageSettingGetter.getFunctionWording(setting, 'TitleWording');
        document.title = title;
        vm.title = title;
      });
  },
  beforeRouteLeave(to, from, next) {
    const vm = this;
    if (vm.isAnswerChanged) {
      vm.popup = {
        isOpen: true,
        title: vm.$t('global.leave-without-save'),
        content: vm.$t('global.leave-without-save-warn'),
        mode: 'default',
        confirm: () => { next(); },
        close: () => {
          vm.popup.isOpen = false;
          next(false);
        },
      };
      next(false);
    } else {
      next();
    }
  },
};
</script>
